import { render } from "./StatsUmfrage.vue?vue&type=template&id=71fc4dc7"
import script from "./StatsUmfrage.vue?vue&type=script&lang=js"
export * from "./StatsUmfrage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__